import { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { holeLocationAuthHelper, kartenStilUrl } from '../lib/locationAuth';

/**
 * Kleine Karte mit einem verschiebbaren Pin — für die Positionskorrektur
 * beim Anlegen einer Eisdiele (Bauphase 3). Keine Cluster, kein Filter,
 * kein Legende — das ist die große Kartenansicht aus Bauphase 6.
 */
export function MiniKarte({
  lat,
  lng,
  onChange,
  hoehe = 220,
}: {
  lat: number;
  lng: number;
  onChange: (lat: number, lng: number) => void;
  hoehe?: number;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<maplibregl.Map | null>(null);
  const markerRef = useRef<maplibregl.Marker | null>(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (!containerRef.current) return;
    let abgebrochen = false;

    holeLocationAuthHelper()
      .then((helper) => {
        if (abgebrochen || !containerRef.current) return;
        const map = new maplibregl.Map({
          container: containerRef.current,
          style: kartenStilUrl(),
          center: [lng, lat],
          zoom: 15,
          transformRequest: helper.getMapAuthenticationOptions().transformRequest,
          attributionControl: false,
        });
        map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');

        const marker = new maplibregl.Marker({ draggable: true, color: '#c2415c' })
          .setLngLat([lng, lat])
          .addTo(map);
        marker.on('dragend', () => {
          const pos = marker.getLngLat();
          onChangeRef.current(pos.lat, pos.lng);
        });

        mapRef.current = map;
        markerRef.current = marker;
      })
      .catch((e) => console.error('Mini-Karte konnte nicht geladen werden:', e));

    return () => {
      abgebrochen = true;
      mapRef.current?.remove();
      mapRef.current = null;
      markerRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // externe Positionsänderungen (z. B. aus der Adresssuche) nachziehen
  useEffect(() => {
    if (markerRef.current && mapRef.current) {
      markerRef.current.setLngLat([lng, lat]);
      mapRef.current.easeTo({ center: [lng, lat], duration: 400 });
    }
  }, [lat, lng]);

  return (
    <div>
      <div
        ref={containerRef}
        style={{ height: hoehe, borderRadius: 'var(--radius)', overflow: 'hidden', border: '1px solid var(--raspel)' }}
      />
      <p className="label" style={{ marginTop: '0.35rem' }}>
        Pin bei Bedarf ziehen, um die Position zu korrigieren.
      </p>
    </div>
  );
}
